import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import FloatingCard from './FloatingCard';

const styles = () => ({
  root: {
    overflow: 'unset',
    maxWidth: '61.8vw',
    margin: 'auto',
  },
});

const NewTrackableCard = (props) => {
  const { classes, children } = props;
  return (
    <FloatingCard className={classes.root}>
      {children}
    </FloatingCard>
  );
};

NewTrackableCard.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  children: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(styles)(NewTrackableCard);
